class TSCartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.cartToggle = document.querySelector(
        ".ts-header__control[data-cart]"
      )),
      (this.overlay = document.querySelector(".ts-cart__overlay[data-close]")),
      (this.isEmpty = this.hasAttribute("data-empty")),
      (this.isLoading = !1),
      (this.scrollPosition = 0),
      (this.discountForm = this.querySelector("#TSCartDiscountForm")),
      (this.timer = this.querySelector("#TSCartTimer") ?? null),
      (this.timerInterval = null),
      (this.timerTime = 5 * 60),
      this.cartToggle &&
        this.cartToggle.addEventListener("click", (e) => {
          e.preventDefault(), this.open();
        }),
      this.overlay &&
        this.overlay.addEventListener("click", () => {
          this.close();
        }),
      this.addEventListener("click", (e) => {
        if (e.target.hasAttribute("data-trigger"))
          switch (e.target.dataset.trigger) {
            case "close":
              this.close();
              break;
            case "discount":
              const discountInputValue = e.target
                .closest("#TSCartDiscountForm")
                .querySelector("input")
                .value.replaceAll(" ", "-");
              discountInputValue !== "" &&
                this.applyDiscount(discountInputValue);
              break;
            case "discount-remove":
              this.applyDiscount("TS-REMOVE-DISCOUNT");
              break;
            case "quantity":
              if (this.isLoading) break;
              const item = e.target.closest("[data-item]"),
                variant = item.dataset.item;
              let quantity = parseInt(
                item.querySelector('input[name="quantity"]').value
              );
              e.target.hasAttribute("data-plus")
                ? (quantity += 1)
                : e.target.hasAttribute("data-minus") && (quantity -= 1),
                this.updateQuanity(variant, quantity);
              break;
            case "upsell-add":
              if (this.isLoading) break;
              const upsellProductItem = e.target.closest(
                  ".ts-cart__upsell-product"
                ),
                upsellProduct = parseInt(
                  upsellProductItem.querySelector(
                    'input[name="current_variant"]'
                  ).value
                );
              this.addUpsellItem(upsellProduct);
              break;
          }
      }),
      this.addEventListener("change", (e) => {
        const upsellProductItem = e.target.closest(".ts-cart__upsell-product");
        if (!upsellProductItem) return;
        const option = e.target.options[e.target.selectedIndex];
        (upsellProductItem.querySelector(
          'input[name="current_variant"]'
        ).value = option.value),
          (upsellProductItem.querySelector(".ts-price--compare").innerHTML =
            option.dataset.compare),
          (upsellProductItem.querySelector(".ts-price--main").innerHTML =
            option.dataset.price);
      }),
      this.discountForm &&
        this.discountForm
          .querySelector("input")
          .addEventListener("keyup", (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const newDiscount = e.target.value.replaceAll(" ", "-");
              newDiscount !== "" && this.applyDiscount(newDiscount);
            }
          }),
      this.timer &&
        (this.timerInterval = setInterval(() => {
          let minutes = Math.floor(this.timerTime / 60),
            seconds = this.timerTime % 60;
          (minutes = minutes < 10 ? "0" + minutes : minutes),
            (seconds = seconds < 10 ? "0" + seconds : seconds),
            (this.timer.textContent = `${minutes}:${seconds}`),
            this.timerTime === 0 && clearInterval(this.timerInterval),
            this.timerTime--;
        }, 1e3));
  }
  applyDiscount(discount) {
    this.toggleLoading(),
      fetch(`/discount/${discount}`)
        .then((res) => res.text())
        .then((res) => {
          const html = new DOMParser().parseFromString(res, "text/html");
          this.renderContent(!1, html);
        })
        .finally(this.toggleLoading.bind(this));
  }
  updateQuanity(item, quantity) {
    this.toggleLoading();
    const data = {
      id: `${item}`,
      quantity: `${quantity}`,
      sections: ["ts-cart-drawer"],
      sections_url: window.location.pathname,
    };
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        this.renderContent(response.sections);
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(this.toggleLoading.bind(this));
  }
  addUpsellItem(upsellProduct, quantity = 1) {
    this.toggleLoading();
    const cartData = {
      items: [{ id: upsellProduct, quantity }],
      sections: ["ts-cart-drawer"],
      sections_url: window.location.pathname,
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.items) this.renderContent(response.sections), this.open();
        else throw new Error(response.description);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(this.toggleLoading.bind(this));
  }
  renderContent(sections, readyHtml = void 0) {
    if (!sections["ts-cart-drawer"] && !readyHtml) return;
    let html;
    if (
      (readyHtml
        ? (html = readyHtml)
        : (html = new DOMParser().parseFromString(
            sections["ts-cart-drawer"],
            "text/html"
          )),
      this.setAttribute(
        "data-count",
        html.querySelector("ts-cart").dataset.count
      ),
      document.querySelector("#TSCartCount") &&
        (console.log(html.querySelector("ts-cart").dataset.count == "0"),
        html.querySelector("ts-cart").dataset.count == "0"
          ? (document.querySelector("#TSCartCount").innerText = "")
          : (document.querySelector("#TSCartCount").innerText =
              html.querySelector("ts-cart").dataset.count)),
      html.querySelector("ts-cart").hasAttribute("data-empty") !== this.isEmpty)
    ) {
      (this.innerHTML = html.querySelector("ts-cart").innerHTML),
        (this.isEmpty = html
          .querySelector("ts-cart")
          .hasAttribute("data-empty")),
        this.timer ||
          ((this.timer = this.querySelector("#TSCartTimer") ?? null),
          (this.timerInterval = setInterval(() => {
            let minutes = Math.floor(this.timerTime / 60),
              seconds = this.timerTime % 60;
            (minutes = minutes < 10 ? "0" + minutes : minutes),
              (seconds = seconds < 10 ? "0" + seconds : seconds),
              (this.timer.textContent = `${minutes}:${seconds}`),
              this.timerTime === 0 && clearInterval(this.timerInterval),
              this.timerTime--;
          }, 1e3)));
      
      return;
    }
    const selectors = [
      ".ts-cart__count",
      ".ts-cart__free-label",
      ".ts-cart__items",
      ".ts-cart__subtotal",
      ".ts-cart__upsell-wrapper",
      ".ts-cart__savings",
      ".ts-cart__discount",
      ".ts-cart__subtotal-compare-diff",
    ];
        if (html.querySelector("ts-cart").dataset.count == "0") {
            this.querySelector(".ts-cart__items-wrapper").classList.add("emptycart");
            this.querySelector(".ts-cart__bottom").classList.add("emptycart");
            console.log("empty");
        } else {
            this.querySelector(".ts-cart__items-wrapper").classList.remove("emptycart");
            this.querySelector(".ts-cart__bottom").classList.remove("emptycart");
            console.log("not empty");
        }
    (this.querySelector(".ts-cart__free-load").style.width =
      html.querySelector(".ts-cart__free-load").dataset.diff + "%"),
      selectors.forEach((selector) => {
        this.querySelector(selector) &&
          html.querySelector(selector) &&
          (this.querySelector(selector).innerHTML =
            html.querySelector(selector).innerHTML);
      });
  }
  open() {
    const header = document.querySelector("ts-header"),
      allAnnouncementsHeight = Math.max(
        document.querySelector(".ts-header-group").offsetHeight -
          header.offsetHeight,
        1
      );
    this.classList.add("open"),
      this.togglePageScroll(!0),
      this.scrollPosition >= allAnnouncementsHeight &&
        header.classList.add("sticky-menu"),
      document.querySelector(".intercom-lightweight-app") &&
        (document.querySelector(".intercom-lightweight-app").style.display =
          "none");
  }
  togglePageScroll(isOpen = !1) {
    isOpen
      ? ((this.scrollPosition = window.scrollY),
        (document.body.style.overflow = "hidden"),
        (document.body.style.position = "fixed"),
        (document.body.style.top = `-${this.scrollPosition}px`),
        (document.body.style.width = "100%"))
      : (document.body.style.removeProperty("overflow"),
        document.body.style.removeProperty("position"),
        document.body.style.removeProperty("top"),
        document.body.style.removeProperty("width"),
        window.scrollTo(0, this.scrollPosition));
  }
  close() {
    const header = document.querySelector("ts-header");
    this.classList.remove("open"),
      this.togglePageScroll(!1),
      header.classList.remove("sticky-menu"),
      document.querySelector(".intercom-lightweight-app") &&
        (document.querySelector(".intercom-lightweight-app").style.display =
          null);
  }
  toggleLoading() {
    (this.isLoading = !this.isLoading),
      this.classList.toggle("loading", this.isLoading);
  }
}
customElements.define("ts-cart", TSCartDrawer);
